var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lifestyle / Sport"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5868 13.9465C10.6068 14.0532 10.5468 14.1665 10.4468 14.2065C9.69347 14.5065 8.86682 14.6665 8.01349 14.6665C6.54016 14.6665 5.18014 14.1932 4.08014 13.3798C3.98681 13.3132 3.96016 13.1798 4.02016 13.0798C4.38683 12.4265 5.82013 10.3265 8.9868 9.15317C9.1068 9.1065 9.24013 9.16649 9.28013 9.28649C10.0735 11.4132 10.4468 13.2132 10.5868 13.9465Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5469 9.25985C14.2402 10.8998 13.3202 12.3265 12.0335 13.2998C11.8935 13.4065 11.6935 13.3265 11.6602 13.1598C11.5202 12.4398 11.1802 10.8865 10.5268 9.03984C10.4802 8.89984 10.5735 8.7465 10.7202 8.7265C12.3802 8.5265 13.8335 8.8465 14.3802 8.99317C14.4935 9.03317 14.5668 9.14652 14.5469 9.25985Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3935 7.87984C13.7135 7.75984 11.9802 7.50649 10.2068 7.69982C10.1002 7.71316 10.0069 7.65316 9.96019 7.55316C9.93352 7.49316 9.91353 7.43316 9.88686 7.37316C9.78019 7.1265 9.66686 6.87317 9.55353 6.6265C9.49353 6.5065 9.55352 6.35983 9.67352 6.30649C11.5402 5.49983 12.5802 4.45983 12.9868 3.99316C13.0868 3.87983 13.2602 3.8865 13.3535 4.0065C14.1202 5.0265 14.5935 6.27316 14.6669 7.61983C14.6735 7.78649 14.5402 7.9065 14.3935 7.87984Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2935 3.19318C11.9468 3.61318 10.9735 4.61316 9.12684 5.3465C9.02018 5.39316 8.89351 5.34649 8.83351 5.23983C7.98017 3.69316 7.07349 2.39316 6.65349 1.8065C6.55349 1.6665 6.63352 1.46651 6.80018 1.43984C7.18685 1.37317 7.59351 1.33984 8.00685 1.33984C9.62018 1.33984 11.1069 1.91317 12.2602 2.87317C12.3602 2.9465 12.3735 3.09318 12.2935 3.19318Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34684 5.89317C4.82018 6.52651 2.58681 6.61318 1.77348 6.62651C1.62015 6.62651 1.50684 6.47984 1.54684 6.33317C2.02684 4.46651 3.30682 2.90651 4.99349 2.04651C5.09349 1.99318 5.22016 2.0265 5.28683 2.11984C5.63349 2.59984 6.57349 3.95318 7.49349 5.54651C7.56682 5.67985 7.50018 5.85317 7.34684 5.89317Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61348 7.73317C8.67348 7.85983 8.60017 8.01316 8.46684 8.05983C5.5135 9.01316 3.74683 11.3798 3.2135 12.1932C3.12683 12.3265 2.94017 12.3332 2.84017 12.2132C1.90684 11.0665 1.34017 9.75315 1.34017 8.15982V8.03983C1.34017 7.90649 1.44683 7.79982 1.58016 7.80649C2.42016 7.83982 5.16017 7.72648 8.00684 6.90648C8.1135 6.87315 8.23348 6.9265 8.28015 7.0265C8.39349 7.25983 8.50682 7.49317 8.61348 7.73317Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportWhiteIcon);
export default __webpack_public_path__ + "static/media/SportWhiteIcon.e8ba30f0e68a86d25ba4a0d9e799c08d.svg";
export { ForwardRef as ReactComponent };